// Scroll-reveal animations powered by Motion (motion.dev) — the
// non-React sibling of Framer Motion, loaded from a CDN since this
// theme has no build step / npm.
//
// Usage: add data-animate to any element in a section/snippet.
//   <div data-animate>...</div>            -> fade + slide up (default)
//   <div data-animate="fade">...</div>      -> fade only, no movement
//   <div data-animate="scale">...</div>     -> fade + gentle scale-in
//
// Optional data-animate-delay="0.15" (seconds) to stagger a group of
// elements, and data-animate-once="false" to replay every time the
// element re-enters the viewport instead of only the first time.
import { animate, inView } from "https://cdn.jsdelivr.net/npm/motion@11/+esm";

const VARIANTS = {
  "fade-up": { from: { opacity: 0, transform: "translateY(24px)" }, to: { opacity: 1, transform: "translateY(0px)" } },
  fade: { from: { opacity: 0 }, to: { opacity: 1 } },
  scale: { from: { opacity: 0, transform: "scale(0.94)" }, to: { opacity: 1, transform: "scale(1)" } },
};

function revealElement(el) {
  const variant = VARIANTS[el.dataset.animate] || VARIANTS["fade-up"];
  const delay = parseFloat(el.dataset.animateDelay || "0");
  animate(el, variant.to, { duration: 0.6, delay, easing: "ease-out" });
}

function setUp() {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const elements = document.querySelectorAll("[data-animate]");

  elements.forEach((el) => {
    const variant = VARIANTS[el.dataset.animate] || VARIANTS["fade-up"];
    if (prefersReducedMotion) {
      // Skip straight to the resting state — no motion, just present.
      Object.assign(el.style, variant.to);
      return;
    }
    Object.assign(el.style, variant.from);
    const once = el.dataset.animateOnce !== "false";
    inView(
      el,
      () => {
        revealElement(el);
        return once ? undefined : () => Object.assign(el.style, variant.from);
      },
      { margin: "0px 0px -10% 0px" }
    );
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setUp);
} else {
  setUp();
}

// Shopify theme editor re-renders sections on edit without a full page
// reload — re-scan for newly injected [data-animate] elements whenever
// that happens so animations keep working while editing the theme.
document.addEventListener("shopify:section:load", setUp);
